import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=3eb64cd2&scoped=true"
import script from "./SupportButton.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportButton.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SupportButton.vue?vue&type=style&index=0&id=3eb64cd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3eb64cd2",
  null
  
)

export default component.exports